import { gql } from '@apollo/client';
import { NSC_SUBJECT_DATA } from '../../fragments';

export const EXPORT_FUNDER_NSC_SUBJECT = gql`
  query ExportFunderNSCSubjectData($input: ExportArgs!) {
    exportFunderNSCSubjectData(input: $input) {
      id
      name
      class
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subject {
        id
        name
        subjectGradeReference
      }
      nscSubjectData {
        ...nscSubjectData
      }
    }
  }
  ${NSC_SUBJECT_DATA}
`;
